import FormPhone from './form-phone';
export default FormPhone;